import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { KSK2011_R01DetailDto, KSK2011_R01Dto, KSK2011_R01EditDto } from "./Dto_KSK2011_R01";
import { KSK2011_R01Filter } from "./Store_KSK2011_R01";
import { KSK2020_R01DetailDto } from "../KSK2020_R01/Dto_KSK2020_R01";
import { StockDto } from "src/dtos/stock/stockDto";

const baseUrl = `${config.apiUrl}/KSK2011_R01`;

const getParams = (filter: Partial<KSK2011_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd,
		workplaceCd: filter.workplaceCd,
		jobTeam: filter.jobTeam,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		closeTag: filter.closeTag,
		listLength: listLength || 0
	}
}

export const getKSK2011_R01List = async (option: string, params: Partial<KSK2011_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`

    return await getData<ResponseDto<KSK2011_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getKSK2011_R01AllCount = async (params: Partial<KSK2011_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}


export const getKSK2011_R01DetailList = async (itemCd: string) => {
	const url = `${baseUrl}/detail/${itemCd}`;

	return await getData<ResponseDto<KSK2011_R01DetailDto[]>>(url);
}

export const getKSK2011_R01DetailMaterialList = async (itemCd: string) => {
	const url = `${baseUrl}/detail/material/${itemCd}`;
	return await getData<ResponseDto<StockDto[]>>(url);
}

export const getKSK2011_R01DetailProductList = async (workplaceCd: string, itemCd: string) => {
	const url = `${baseUrl}/detail/product/${workplaceCd}/${itemCd}`;
	return await getData<ResponseDto<StockDto[]>>(url);
}

export const postKSK2011_R01 = async (data: KSK2011_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<KSK2011_R01Dto[], ResponseDto<KSK2011_R01Dto[]>>(url, data);
}

export const patchKSK2011_R01 = async (data: KSK2011_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<KSK2011_R01Dto[], ResponseDto<KSK2011_R01Dto[]>>(url, data);
}

export const deleteKSK2011_R01 = async (userId: string) => {
    let url = `${baseUrl}/${userId}`;

    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_KSK2011_R01 = async (option: string, params: Partial<KSK2011_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, { params: getParams(params, listLength) });
}

//여기서부턴 공정지시 관련 함수

export const getKSK2011_R01WorkOne = async (productOrderNo: string) => {
    const url = `${baseUrl}/work/one/${productOrderNo}`;
    return await getData<ResponseDto<KSK2011_R01EditDto>>(url);
}

export const getKSK2011_R01WorkStockOne = async (productOrderNo: string) => {
    const url = `${baseUrl}/work/one/stock/${productOrderNo}`;
    return await getData<ResponseDto<KSK2011_R01EditDto>>(url);
}



export const postKSK2011_R01Work = async (data: KSK2011_R01EditDto) => {
    const url = `${baseUrl}/work`;
    return await postData<KSK2011_R01EditDto, ResponseDto<KSK2011_R01EditDto>>(url, data);
}

export const patchKSK2011_R01Work = async (data: KSK2011_R01EditDto) => {
    const url = `${baseUrl}/work`;
    return await patchData<KSK2011_R01EditDto, ResponseDto<KSK2011_R01EditDto>>(url, data);
}

export const deleteKSK2011_R01Work = async (productWorkNo: string) => {
    const url = `${baseUrl}/work/${productWorkNo}`;
    return await deleteData<ResponseDto<any>>(url);
}